var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A0A0AB;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,17L12,17c0.6,0,1-0.4,1-1v-4c0-0.6-0.4-1-1-1h0c-0.6,0-1,0.4-1,1v4C11,16.6,11.4,17,12,17z M12,9 c0.3,0,0.5-0.1,0.7-0.3C12.9,8.5,13,8.3,13,8s-0.1-0.5-0.3-0.7S12.3,7,12,7s-0.5,0.1-0.7,0.3S11,7.7,11,8s0.1,0.5,0.3,0.7 C11.5,8.9,11.7,9,12,9z M12,22c-1.4,0-2.7-0.3-3.9-0.8S5.8,20,4.9,19.1c-0.9-0.9-1.6-2-2.1-3.2S2,13.4,2,12s0.3-2.7,0.8-3.9 S4,5.8,4.9,4.9s2-1.6,3.2-2.1S10.6,2,12,2s2.7,0.3,3.9,0.8s2.3,1.2,3.2,2.1s1.6,2,2.1,3.2C21.7,9.3,22,10.6,22,12s-0.3,2.7-0.8,3.9 c-0.5,1.2-1.2,2.3-2.1,3.2c-0.9,0.9-2,1.6-3.2,2.1S13.4,22,12,22z M12,20c2.2,0,4.1-0.8,5.7-2.3c1.5-1.5,2.3-3.4,2.3-5.7 s-0.8-4.1-2.3-5.7C16.1,4.8,14.2,4,12,4S7.9,4.8,6.3,6.3S4,9.8,4,12s0.8,4.1,2.3,5.7C7.9,19.2,9.8,20,12,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7989d6e1ba248dfd3388f9a79b23f901.svg";
export { ForwardRef as ReactComponent };